export const N63_REFERENCE = {
  meta: {
    cuaderno: '63',
    version: '63033',
    recordLength: 650,
    encoding: 'ASCII en mayúsculas',
    lineEnding: 'CRLF',
  },
  overview: [
    {
      fase: '1',
      nombre: 'Solicitud de información',
      objetivo: 'El organismo emisor solicita a la entidad las cuentas a la vista de los deudores incluidos en la PAY.',
      usaRegistros: ['4', '6', '8'],
      notas: [
        'Un fichero por banco (NRBE).',
        'No lleva importes ni IBANs.',
        'Los detalles se ordenan por NIF del deudor.',
      ],
    },
    {
      fase: '2',
      nombre: 'Respuesta bancaria',
      objetivo: 'La entidad devuelve hasta 6 cuentas IBAN por deudor y sus claves de seguridad.',
      usaRegistros: ['4', '6', '8'],
      notas: [
        'Mantiene la identificación del deudor y de la deuda.',
        'Si no encuentra cuentas, deja los campos de IBAN a blancos.',
        'Cada clave de seguridad ocupa 12 posiciones; las 8 primeras son fecha AAAAMMDD.',
      ],
    },
    {
      fase: '3',
      nombre: 'Orden de ejecución de embargo',
      objetivo: 'El organismo emisor ordena el embargo usando los IBANs válidos devueltos en la Fase 2.',
      usaRegistros: ['4', '6', '7 opcional', '8'],
      notas: [
        'Lleva importe a embargar por cada deudor.',
        'La zona J contiene los IBANs en orden de prelación.',
        'El registro tipo 7 es complementario y opcional.',
      ],
    },
  ],
  commonChecks: [
    'Cada registro debe medir exactamente 650 caracteres.',
    'Cabecera tipo 4 al inicio y fin de fichero tipo 8 al final.',
    'Campos numéricos: ceros a la izquierda. Alfanuméricos: blancos a la derecha.',
    'Fechas en AAAAMMDD.',
    'IBAN de 24 posiciones.',
    'Importes sin coma decimal; las dos últimas posiciones son decimales.',
  ],
  records: {
    commonHeader: {
      codigo: '4',
      nombre: 'Cabecera de emisor',
      finalidad: 'Identifica fase, banco destino, fechas, organismo emisor y versión del cuaderno.',
      fields: [
        { zona: 'A', pos: '1', longitud: 1, tipo: 'N', nombre: 'Código de registro', regla: 'Valor fijo 4' },
        { zona: 'B', pos: '2-3', longitud: 2, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'C', pos: '4-7', longitud: 4, tipo: 'N', nombre: 'Código NRBE entidad depósito' },
        { zona: 'D', pos: '8-15', longitud: 8, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'E', pos: '16-23', longitud: 8, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'F1', pos: '24', longitud: 1, tipo: 'N', nombre: 'Indicador de fase', regla: '1 / 2 / 3 según fichero' },
        { zona: 'F2', pos: '25-32', longitud: 8, tipo: 'Fecha', nombre: 'Fecha de obtención por organismo', regla: 'AAAAMMDD' },
        { zona: 'F3', pos: '33-40', longitud: 8, tipo: 'Fecha', nombre: 'Fecha de obtención por entidad', regla: 'En F1 y F3 va a ceros; en F2 lleva fecha real' },
        { zona: 'F4', pos: '41-54', longitud: 14, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'F5', pos: '55-56', longitud: 2, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'G1', pos: '57-65', longitud: 9, tipo: 'AN', nombre: 'NIF organismo emisor' },
        { zona: 'G2', pos: '66-71', longitud: 6, tipo: 'N', nombre: 'Código INE + dígito control' },
        { zona: 'G3', pos: '72-111', longitud: 40, tipo: 'AN', nombre: 'Nombre organismo emisor' },
        { zona: 'H1', pos: '112-116', longitud: 5, tipo: 'N', nombre: 'Versión del cuaderno', regla: '63033' },
        { zona: 'H2', pos: '117-650', longitud: 534, tipo: 'Libre', nombre: 'Libre' },
      ],
    },
    commonFooter: {
      codigo: '8',
      nombre: 'Fin de fichero',
      finalidad: 'Cierra el fichero y resume totales y datos del emisor.',
      fields: [
        { zona: 'A', pos: '1', longitud: 1, tipo: 'N', nombre: 'Código de registro', regla: 'Valor fijo 8' },
        { zona: 'B', pos: '2-3', longitud: 2, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'C', pos: '4-7', longitud: 4, tipo: 'N', nombre: 'Código NRBE entidad depósito' },
        { zona: 'D', pos: '8-15', longitud: 8, tipo: 'N', nombre: 'Número total de registros del fichero', regla: 'Incluye cabecera, detalles, complementarios y este pie' },
        { zona: 'E', pos: '16-23', longitud: 8, tipo: 'Libre', nombre: 'Libre' },
        { zona: 'F1', pos: '24-38', longitud: 15, tipo: 'Importe', nombre: 'Importe total a embargar/levantar', regla: 'En F1 y F2 va a ceros' },
        { zona: 'F2', pos: '39-53', longitud: 15, tipo: 'Importe', nombre: 'Importe total retenido', regla: 'En F1/F2/F3 normalmente a ceros salvo fases de retorno' },
        { zona: 'G1', pos: '54-62', longitud: 9, tipo: 'AN', nombre: 'NIF organismo emisor' },
        { zona: 'G2', pos: '63-68', longitud: 6, tipo: 'N', nombre: 'Código INE + dígito control' },
        { zona: 'G3', pos: '69-108', longitud: 40, tipo: 'AN', nombre: 'Nombre organismo emisor' },
        { zona: 'H', pos: '109-650', longitud: 542, tipo: 'Libre', nombre: 'Libre' },
      ],
    },
    phase1Detail: {
      codigo: '6',
      nombre: 'Detalle Fase 1',
      finalidad: 'Identifica al deudor sobre el que se solicita información bancaria.',
      fields: [
        { zona: 'A', pos: '1', longitud: 1, tipo: 'N', nombre: 'Código de registro', regla: 'Valor fijo 6' },
        { zona: 'B1', pos: '2-10', longitud: 9, tipo: 'AN', nombre: 'NIF del deudor' },
        { zona: 'B2', pos: '11-50', longitud: 40, tipo: 'AN', nombre: 'Nombre / razón social', regla: 'Persona física: APELLIDO1*APELLIDO2*NOMBRE' },
        { zona: 'B3', pos: '51-89', longitud: 39, tipo: 'AN', nombre: 'Domicilio del deudor' },
        { zona: 'B4', pos: '90-101', longitud: 12, tipo: 'AN', nombre: 'Municipio' },
        { zona: 'B5', pos: '102-106', longitud: 5, tipo: 'N', nombre: 'Código postal' },
        { zona: 'C', pos: '107-119', longitud: 13, tipo: 'AN', nombre: 'Identificador de deuda', regla: 'Debe mantenerse invariable en todas las fases' },
        { zona: 'D', pos: '120-134', longitud: 15, tipo: 'Libre', nombre: 'Libre en Fase 1' },
        { zona: 'E', pos: '135-142', longitud: 8, tipo: 'AN', nombre: 'Código de deuda/deudor', regla: 'Opcional; la entidad lo devuelve sin procesar' },
        { zona: 'F-M', pos: '143-650', longitud: 508, tipo: 'Libre', nombre: 'Resto a blancos' },
      ],
    },
    phase2Detail: {
      codigo: '6',
      nombre: 'Detalle Fase 2',
      finalidad: 'Devuelve cuentas localizadas y claves de seguridad para cada deudor.',
      base: 'Reutiliza A, B, C y E de Fase 1',
      fields: [
        { zona: 'A-C/E', pos: '1-142', longitud: 142, tipo: 'Mixto', nombre: 'Identificación deudor + deuda', regla: 'Misma base que Fase 1' },
        { zona: 'J1', pos: '175-198', longitud: 24, tipo: 'AN', nombre: 'IBAN 1' },
        { zona: 'J4', pos: '216-239', longitud: 24, tipo: 'AN', nombre: 'IBAN 2' },
        { zona: 'J7', pos: '257-280', longitud: 24, tipo: 'AN', nombre: 'IBAN 3' },
        { zona: 'J10', pos: '298-321', longitud: 24, tipo: 'AN', nombre: 'IBAN 4' },
        { zona: 'J13', pos: '339-362', longitud: 24, tipo: 'AN', nombre: 'IBAN 5' },
        { zona: 'J16', pos: '380-403', longitud: 24, tipo: 'AN', nombre: 'IBAN 6' },
        { zona: 'L1', pos: '427-438', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 1', regla: 'AAAAMMDD + 4 posiciones internas' },
        { zona: 'L2', pos: '439-450', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 2' },
        { zona: 'L3', pos: '451-462', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 3' },
        { zona: 'L4', pos: '463-474', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 4' },
        { zona: 'L5', pos: '475-486', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 5' },
        { zona: 'L6', pos: '487-498', longitud: 12, tipo: 'AN', nombre: 'Clave seguridad 6' },
      ],
      notes: [
        'Si no hay cuentas, las posiciones de IBAN y claves quedan en blanco.',
        'La fecha incluida en cada clave se usa para validar caducidad en Fase 3.',
      ],
    },
    phase3Detail: {
      codigo: '6',
      nombre: 'Detalle Fase 3',
      finalidad: 'Ordena el embargo indicando importe e IBANs en orden de prelación.',
      base: 'Reutiliza la identificación del deudor de Fase 1.',
      fields: [
        { zona: 'A-C', pos: '1-119', longitud: 119, tipo: 'Mixto', nombre: 'Identificación deudor + deuda', regla: 'Misma base que Fase 1' },
        { zona: 'D', pos: '120-134', longitud: 15, tipo: 'Importe', nombre: 'Importe total a embargar', regla: 'Sin coma; 2 decimales implícitos' },
        { zona: 'E', pos: '135-142', longitud: 8, tipo: 'AN', nombre: 'Código de deuda/deudor' },
        { zona: 'J1', pos: '175-198', longitud: 24, tipo: 'AN', nombre: 'IBAN 1 (prioridad 1)' },
        { zona: 'J4', pos: '216-239', longitud: 24, tipo: 'AN', nombre: 'IBAN 2 (prioridad 2)' },
        { zona: 'J7', pos: '257-280', longitud: 24, tipo: 'AN', nombre: 'IBAN 3 (prioridad 3)' },
        { zona: 'J10', pos: '298-321', longitud: 24, tipo: 'AN', nombre: 'IBAN 4 (prioridad 4)' },
        { zona: 'J13', pos: '339-362', longitud: 24, tipo: 'AN', nombre: 'IBAN 5 (prioridad 5)' },
        { zona: 'J16', pos: '380-403', longitud: 24, tipo: 'AN', nombre: 'IBAN 6 (prioridad 6)' },
        { zona: 'L1-L6', pos: '427-498', longitud: 72, tipo: 'AN', nombre: 'Claves seguridad asociadas', regla: 'Deben corresponder a los IBANs y no estar caducadas' },
      ],
      notes: [
        'La entidad decide la cuenta final siguiendo el orden indicado y sus propias reglas.',
        'No debería generarse Fase 3 para líneas sin IBAN válido en Fase 2.',
      ],
    },
    phase3Complementary: {
      codigo: '7',
      nombre: 'Complementario Fase 3',
      finalidad: 'Registro opcional para información adicional ligada al mismo deudor e identificador de deuda.',
      fields: [
        { zona: 'A', pos: '1', longitud: 1, tipo: 'N', nombre: 'Código de registro', regla: 'Valor fijo 7' },
        { zona: 'B1-B5', pos: '2-106', longitud: 105, tipo: 'Mixto', nombre: 'Misma identificación del deudor que en tipo 6' },
        { zona: 'C', pos: '107-119', longitud: 13, tipo: 'AN', nombre: 'Identificador de deuda' },
        { zona: 'D', pos: '120-134', longitud: 15, tipo: 'Importe', nombre: 'Importe' },
        { zona: 'E1', pos: '135-184', longitud: 50, tipo: 'AN', nombre: 'Texto libre 1' },
        { zona: 'E2', pos: '185-234', longitud: 50, tipo: 'Libre', nombre: 'Texto libre 2' },
        { zona: 'E3', pos: '235-284', longitud: 50, tipo: 'Libre', nombre: 'Texto libre 3' },
        { zona: 'F', pos: '285-650', longitud: 366, tipo: 'Libre', nombre: 'Resto libre' },
      ],
    },
  },
  reviewHints: [
    {
      titulo: 'Si un banco rechaza Fase 1 y otros no',
      detalle: 'Revisar primero cabecera tipo 4, pie tipo 8, longitudes exactas, versión 63033, CRLF y que todos los campos libres vayan realmente a blancos.',
    },
    {
      titulo: 'Campos más sensibles en validación bancaria',
      detalle: 'NRBE, fechas F2/F3 de cabecera, NIF emisor, versión, identificador de deuda, número total de registros del pie y formato exacto del nombre del deudor.',
    },
    {
      titulo: 'Claves de seguridad',
      detalle: 'En Fase 3 deben ir alineadas con el mismo orden de IBANs devuelto en Fase 2 y no haber caducado.',
    },
  ],
  appImplementationNotes: [
    'La app genera Fase 1 y Fase 3 desde backend Node y parsea Fase 2 leyendo posiciones fijas.',
    'Fase 2 y Fase 3 comparten la zona J (IBANs) y la zona L (claves) como referencia principal.',
    'Esta ayuda sirve para contrastar lo que exige la norma con lo que sale del fichero generado o importado en la app.',
  ],
};
